import type { TranslationKey } from '~/shared/internationalization/translation';

export const route = {
    patterns: {
        myGrowth: '/my-growth',
    },
    searchParams: {
        tab: 'tab',
    },
};

export type TabCode = 'bookmarks' | 'featured';

export const tabs: readonly {
    readonly key: TabCode;
    readonly label: TranslationKey;
}[] = [
    {
        key: 'bookmarks',
        label: 'pages.my-growth.tabs.bookmarks',
    },
    {
        key: 'featured',
        label: 'pages.my-growth.tabs.featured',
    },
];
